import React, { useState, useEffect, useRef } from "react";
import { Badge, Button, Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import Switch from "react-switch";
import { connect,useSelector } from "react-redux";
import { activeBot, deleteBot } from "../../actions/bot-action";
import NoData from "../common/NoData";
import "./BotTab.scss";
import { capitalize, currencyFormat, decimalOf, isLong, trimString } from "../../utils/Utils";
import { toast } from "react-toastify";
import { t } from "i18next";
import { Link } from "react-router-dom/cjs/react-router-dom";
import useLoading from "../hooks/useLoading";
import Loading from "../common/Loading";
import CustomSwitch from "./new-bot/modules/CustomSwitch";
import CustomCheckbox from "./new-bot/modules/CustomCheckbox";
import ToolTip from "../help/ToolTip";
import BotReactivationModal from "./BotReactivationModal";

const BotCard = (props) => {
  
  const { bot,itemsPerPage,pageNum,selectedTab,t,clickBotAction,deleteBot} = props;
  
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  const sort = useSelector((state) => state.pagination.botSort) || "name";
  const orderBy = useSelector((state) => state.pagination.botsOrderBy) || "desc";
  const dropdownRef = useRef(null)
  const selectedExchangeId =
    useSelector((state) => state.settings.selectedExchangeId) || 0;
  const [setLoading, bindLoading] = useLoading(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [botStatus, setBotStatus] = useState(bot.status);
  const [openMenu, setOpenMenu] = useState(false);
  const [reactivationData, setReactivationData] = useState(null);
  const pair = bot.exchange_pair.pair;
  const strategy = bot.strategy;
  //const baseCoin = strategy.toLowerCase() == "long" || strategy.toLowerCase() == "margin short" ? pair.to:pair.from;
  const baseCoin = pair.to;
  const handleClickOutside = (event) => {
    // Check if the click is outside of any bot's menu or button
    if (!dropdownRef.current || dropdownRef.current.contains(event.target)) {
      return;
    }
    else{
      setOpenMenu(false)
    }
  };
  useEffect(() => {
    setBotStatus(bot.status);
  }, [bot.status]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const confirmDelete = () => {
    setLoading(true);
    deleteBot(bot.id,selectedExchangeId,itemsPerPage,pageNum,selectedTab,orderBy,sort)
      .then(() => {
        setLoading(false);
        setOpenMenu(false)
        setShowConfirm(false)
        toast.success(t("bot-deleted-msg"));
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
        setShowConfirm(false)
      });
  };
  const clickDelete = () => {
    setShowConfirm(true)
  };
  const isDollar = () => {
    return strategy.toLowerCase() != "short"?selectedExchangeId==1000?"₹":"$":"";
  };
  const submitStatusChange = (nextStatus, reactivationAction = null) => {
    props
      .activeBot(
        bot.id,
        nextStatus,
        selectedExchangeId,
        itemsPerPage,
        pageNum,
        selectedTab,
        orderBy,
        sort,
        reactivationAction
      )
      .then((res) => {
        if (res.requires_reactivation_action) {
          setReactivationData(res);
          setBotStatus(bot.status);
          return;
        }
        setReactivationData(null);
        setBotStatus(nextStatus);
        if (res.message) {
          toast.success(res.message);
        }
      })
      .catch((err) => {
        setBotStatus(bot.status);
        toast.error(err);
      });
  };

  const updateStatus = (checked)=>{
    const nextStatus = checked ? "active" : "inactive";
    submitStatusChange(nextStatus);
  };

  const handleResumeTrade = () => {
    submitStatusChange("active", "resume");
  };

  const handleRestartTrade = () => {
    submitStatusChange("active", "restart");
  };
  //const [startItem, setStartItem] = useState(0);

  
  return (
    <Loading {...bindLoading}>
    <div className="col-xl-4 col-lg-4 col-md-4 col-6" key={bot.id}>
          <div className="main-dna-cart">
            <div className="dna-cart-header" >
              <ul>
                <li>
                    <div className="d-flex align-items-center">
                        <div className="bot-grid-view-checkbox">
                            <CustomCheckbox 
                                id={`bot-card-check-${bot.id}`}
                                checked={props.isSelected || false}
                                callback={() => props.onToggleSelect && props.onToggleSelect(bot.id)}
                            />
                        </div>
                         <div className="rounded-circle bg-white shadow-sm d-flex align-items-center justify-content-center me-2" style={{ width: '28px', height: '28px', padding: '4px' }}>
                              <img 
                                  src={pair.base_image} 
                                  alt="" 
                                  className="w-100 h-100"
                                  style={{ objectFit: 'contain' }}
                              />
                          </div>
                        <h6>{pair.from}/{pair.to}</h6>
                    </div>
                </li>
                <li>
                  {/* <i className="fa-solid fa-heart heart"></i> */}
                  <div className="dropdown" ref={dropdownRef}>
                    <i className="fa-solid fa-ellipsis-vertical" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" onClick={()=>setOpenMenu(openMenu?false:true)}></i>
                    <ul className={`dropdown-menu ${openMenu?"show":""}  dna-cart-dropdown`} aria-labelledby="dropdownMenuButton1">
                        <li>
                        <Link to={`/bot-detail/${bot.id}`} className="dropdown-item">	<img src="images/c-details-icon.png" alt=""/>
                          Details</Link>
                      </li>
                        <li>
                        <a className="dropdown-item" href="#" onClick={()=>clickBotAction('edit')}>
                          <img src="images/c-edit-icon.png" alt=""/>
                          Edit
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#" onClick={!bot.rent_id?()=>clickBotAction('copy'):void(null)}>
                          <img src="images/c-copy-icon.png" alt=""/>
                          Copy
                        </a>
                      </li>
                      {/* <li>
                        <a className="dropdown-item" href="#">
                          <img src="images/c-copy-icon.png" alt=""/>
                          Copy to Broker
                        </a>
                      </li> */}
                      <li>
                        <a className="dropdown-item pointer " onClick={clickDelete}>
                          <img src="images/c-delete-icon.png" alt="" />
                          Delete
                        </a>
                      </li>
                      <div className="dna-cart-dropdown-footer">
                        <span>{bot.status && capitalize(bot.status)}</span>
                        <div className="check-box">
                          <CustomSwitch checked={botStatus=='active' || false} onChange={(checked) => updateStatus(checked)}></CustomSwitch>
                        </div>
                      </div>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
													<div className="dna-cart-body">
														<h4 className={`bot-${bot.statusVariant}`}>{bot.name}{bot.notice != "" &&  <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>{bot.notice}</Tooltip>}
    ><i className="fa fa-exclamation-circle deativate-warning" aria-hidden="true"></i></OverlayTrigger> }</h4>
														<div className="dna-cart-progress">
															<ul>
																<li>Allocated Fund</li>
																<li><b>{isDollar()}{currencyFormat(bot.allocated_fund,0)} / <span>{isDollar()}{currencyFormat(bot.initial_fund,0)}</span></b></li>
															</ul>
															<div className="progress">
																<div className="progress-bar" role="progressbar" style={{width: (bot.initial_fund && (bot.allocated_fund/bot.initial_fund)*100)+'%'}} aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
															</div>
														</div>
														<div className="dna-cart-btc">
															<div className="dna-cart-btc-left">
																<span>Return</span>
																<p>{parseFloat(bot.deals_analysis.total_performance).toFixed(
                                    decimalOf(baseCoin)
                                  ) || "0"}{" "}
                                  {baseCoin}</p>
															</div>
															<div className="dna-cart-btc-right">
																<span>Performance</span>
                                  <p>{parseFloat(bot.deals_analysis.return_value_avg).toFixed(2) || "0"}%</p>
															</div>
														</div>
													</div>
													<div className="dna-footer">
														<a href="#" className={bot.deals_analysis.apy>=0?"long":"short"}><span>APY</span>{bot.deals_analysis.apy}%</a>
														{bot.rent_id?<ToolTip content={bot.template_name}><a href="#" className="strategy_name">{bot.template_name && trimString(bot.template_name,14)}</a></ToolTip>:<></>}
														<a className={isLong(bot.strategy) ? "long" : "short"}>{bot.strategy}</a>
													</div>
												</div>
											</div>
                      <ConfirmDialog show={showConfirm} onHide={() => setShowConfirm(false)} delete={confirmDelete}/>
                      <BotReactivationModal
                        show={!!reactivationData}
                        onHide={() => setReactivationData(null)}
                        onResume={handleResumeTrade}
                        onRestart={handleRestartTrade}
                        message={reactivationData?.message}
                        symbol={reactivationData?.symbol}
                        qty={reactivationData?.qty}
                      />
    </Loading>
    
  );
};

export default connect(null, { activeBot,deleteBot })(BotCard);
const ConfirmDialog = (props) => {
  const clickClose = () => {
    props.onHide();
  };
  const clickCancel = () => props.onHide();
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <Modal.Title>Confirm Dialog</Modal.Title>
      </Modal.Header>
      <Modal.Body>Please confirm that you would like to delete this bot by clicking the Delete button below.</Modal.Body>
      <Modal.Footer>
        <button className="red-button" onClick={props.delete}>
          Delete
        </button>
        <button className="grey-button" onClick={clickCancel}>
          Cancel
        </button>
      </Modal.Footer>
    </Modal>
  );
};
